// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3Q0FN","list":"PatternAutocomplete_list__3Qv3j"};